import PropTypes from 'prop-types';
import { memo } from 'react';
import _ from 'lodash';
import Amenities from '../../AmenitiesDetails';

const RateDetail = ({ product }) => (
  <div className="col-span-9 mb-2 mt-1">
    {!product.additional_info && !(product.amenities || []).length > 0
      && !(product.valueAdds || []).length > 0 ? <i>Rate details not found!</i> : (
        <>
          {product.rooms[0].category && (
          <div className="mb-2">
            <b>Product category:</b>
            {' '}
            {product.rooms[0].category}
          </div>
          )}
          {product.amenities && product.amenities.length > 0 && (
          <div className="mb-2">
            <Amenities roomAmenities={product.amenities} />
          </div>
          )}
          {product.rooms && product.rooms[0] && product.rooms[0].bedTypes
          && product.rooms[0].bedTypes.length > 0
          && (
            <div className="mb-2">
              Bed type(s):
              {' '}
              {product.rooms[0].bedTypes.map((v) => (<div key={v} className="inline mr-2">{v}</div>))}
            </div>
          )}
          {product.valueAdds && product.valueAdds.length > 0
          && (
            <div className="mb-2">
              Meal:
              {' '}
              {_.join(product.valueAdds, ', ')}
            </div>
          )}
          <div dangerouslySetInnerHTML={{ __html: product.additional_info }} />
        </>
      )}
  </div>
);

RateDetail.propTypes = {
  product: PropTypes.shape().isRequired,
};
export default memo(RateDetail);
